import { Flex, Spin, Tag } from 'antd';
import { useGetWarehousesForClientOffice } from 'client-app/api/warehouses/use-get-warehouses-for-client-office.ts';
import { ClientCargoStatusesInfoModal } from 'client-app/components/client/client-cargo-statuses-info-modal/client-cargo-statuses-info-modal.tsx';
import { CargoItemStatus } from './cargo-item-status.tsx';
import type { ICargoItemStatusesProps } from './types.ts';

const SORTING_ORDER_BY_TYPE = {
  waiting: 0,
  planned: 1,
  warehouse: 2,
  loaded: 3,
  delivered: 4,
};

export const CargoItemStatuses: React.FC<ICargoItemStatusesProps> = (props) => {
  const { statuses } = props;
  const { isLoading } = useGetWarehousesForClientOffice();

  if (isLoading) return <Spin />;

  if (!statuses.length) return <Tag color='volcano'>no cargoes</Tag>;

  const sortedStatuses = [...statuses].sort((itemA, itemB) => {
    return SORTING_ORDER_BY_TYPE[itemA.type] - SORTING_ORDER_BY_TYPE[itemB.type];
  });

  return (
    <Flex gap={6} wrap='wrap'>
      {sortedStatuses.map((status) => (
        <CargoItemStatus
          key={`${status.type}${status.fromWarehouseId}${status.toWarehouseId}`}
          type={status.type}
          from={status.fromWarehouseId}
          to={status.toWarehouseId}
        />
      ))}
      <ClientCargoStatusesInfoModal statuses={sortedStatuses} />
    </Flex>
  );
};
